import { Icon } from 'ui';
import TextRich from 'core/modules/atoms/TextRich/TextRich';
import PropTypes from 'prop-types';
import React from 'react';
import './LessonRecommendationItem.scss';

/**
 * LessonRecommendationItem - Individual lesson that needs attention
 */
const LessonRecommendationItem = ({ lesson }) => {
  return (
    <div className="lesson-recommendation-item">
      <div className="lesson-recommendation-item__alert">
        <Icon name="exclamation-filled" />
      </div>
      <div className="lesson-recommendation-item__content">
        <TextRich text={lesson.title} />
      </div>
    </div>
  );
};

LessonRecommendationItem.propTypes = {
  lesson: PropTypes.shape({
    lessonId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    order: PropTypes.number,
    alertReasons: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default LessonRecommendationItem;
